<template>
  <div
    class="relative px-4 py-8 sm:p-8 gap-6 flex flex-shrink-0 flex-col text-center bg-[#353535] overflow-hidden"
  >
    <img
      src="/images/capybara-head.png"
      class="absolute top-0 right-0 h-[200px] w-[200px] opacity-5 rotate-[-36deg] translate-x-[50px] translate-y-[-20px] pointer-events-none"
      loading="lazy"
    />

    <!-- <img
      src="/images/capybara-head.png"
      class="absolute bottom-0 left-0 h-[200px] w-[200px] opacity-5 rotate-[36deg] translate-x-[-40px] translate-y-[-50px] pointer-events-none"
      loading="lazy"
    /> -->

    <div class="gap-4 flex items-start justify-between">
      <div class="gap-4 flex items-center">
        <BaseLogo is-big :is-label="false" />

        <div class="gap-2 flex flex-col text-left">
          <span class="font-bold text-[#FFDC64]">{{ headerTitle }}</span>

          <span
            class="text-white text-sm"
            v-html="$t('hub.header.motivation')"
          ></span>
          <!-- <div v-if="isAuthorized && user?.isPremium" class="flex flex-initial">
            <div
              v-if="user?.isPremium"
              class="mt-1 px-2 py-1 text-white bg-gradient-to-r from-[#FFA52F] to-[#CE3434] text-[10px] rounded-full"
            >
              Premium
            </div>
          </div> -->
        </div>
      </div>

      <div class="h-full gap-2 flex flex-col justify-between items-end">
        <BaseIcon
          class="text-white text-2xl cursor-pointer"
          icon="menu-burger"
          @click="sidebar.isVisible = true"
        />

        <div class="gap-1 flex items-center">
          <img class="size-[13px]" src="/icons/star.png" />
          <span class="text-[#FFDC64] text-sm">{{ totalSectionStars }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="!isAuthorized"
      class="gap-4 flex items-center justify-between text-left"
    >
      <span class="w-full text-white text-sm font-medium">
        {{ $t('hub.header.loginPrompt') }}
      </span>

      <div>
        <BaseButton
          class="flex-initial"
          color="primary-gradient"
          size="small"
          :to="{ query: { action: 'open-login' } }"
        >
          {{ $t('hub.header.login') }}
        </BaseButton>
      </div>
    </div>

    <div
      v-else-if="isAuthorized && !user?.isPremium"
      class="ml-auto gap-4 flex items-center justify-end text-left"
    >
      <span class="w-full text-white text-sm font-medium">
        {{ $t('hub.header.premiumPrompt') }}
      </span>

      <div>
        <BaseButton
          class="sm:whitespace-nowrap"
          color="primary-gradient"
          size="small"
          @click="setUiTariffsModalIsVisible(true)"
        >
          {{ $t('hub.header.getPremium') }}
        </BaseButton>
      </div>
    </div>

    <HubSidebar v-if="sidebar.isVisible" @close="sidebar.isVisible = false" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import BaseLogo from '@/components/Base/BaseLogo.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'

import HubSidebar from '@/components/Hub/HubSidebar.vue'

export default {
  name: 'HubHeader',

  components: { BaseLogo, BaseButton, BaseIcon, HubSidebar },

  data: () => ({
    sidebar: {
      isVisible: false
    }
  }),

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized']),

    headerTitle() {
      return this.isAuthorized
        ? this.$t('hub.header.welcome') + ', ' + this.user.name
        : this.$t('hub.header.welcome')
    },

    totalSectionStars() {
      if (!this.user || !this.user.sectionRecords) return 0

      return Object.values(this.user.sectionRecords).reduce(
        (total, section) => {
          return (
            total +
            Object.values(section).reduce((subTotal, subSection) => {
              return subTotal + (subSection.stars || 0)
            }, 0)
          )
        },
        0
      )
    }
  },

  methods: {
    ...mapMutations('ui', {
      setUiTariffsModalIsVisible: 'SET_UI_TARIFFS_MODAL_IS_VISIBLE'
    })
  }
}
</script>
